import React, { useState, useEffect } from 'react';

const getToken = () => localStorage.getItem('rz_token');
const getUser = () => JSON.parse(localStorage.getItem('rz_user') || '{}');

const roleColors = {
  admin: { bg: '#1a0000', color: '#cc0000', border: '#3a0000' },
  manager: { bg: '#001a33', color: '#0066cc', border: '#003366' },
  staff: { bg: '#1a1a00', color: '#ffcc00', border: '#333300' },
};

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'staff', phone: '' });
  const currentUser = getUser();

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    const r = await fetch('/api/users', { headers: { 'Authorization': 'Bearer ' + getToken() } });
    const d = await r.json();
    console.log('Users response:', d);
    setUsers(Array.isArray(d) ? d : []);
    setLoading(false);
  };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openAdd = () => { setEditing(null); setForm({ name: '', email: '', password: '', role: 'staff', phone: '' }); setModal(true); };
  const openEdit = (u) => { setEditing(u); setForm({ name: u.name, email: u.email, password: '', role: u.role, phone: u.phone || '', active: u.active }); setModal(true); };

  const save = async () => {
    setSaving(true);
    if (editing) {
      await fetch('/api/users/' + editing.id, {
        method: 'PUT',
        headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (form.password) {
        await fetch('/api/users/' + editing.id + '/reset-password', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ password: form.password })
        });
      }
    } else {
      const r = await fetch('/api/users', {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const d = await r.json();
      if (d.error) { alert(d.error); setSaving(false); return; }
    }
    setSaving(false);
    setModal(false);
    load();
  };

  const deleteUser = async (id, name) => {
    if (!window.confirm('Delete ' + name + '? They will no longer be able to login.')) return;
    await fetch('/api/users/' + id, { method: 'DELETE', headers: { 'Authorization': 'Bearer ' + getToken() } });
    load();
  };

  const toggleActive = async (u) => {
    await fetch('/api/users/' + u.id, {
      method: 'PUT',
      headers: { 'Authorization': 'Bearer ' + getToken(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...u, active: !u.active })
    });
    load();
  };

  return (
    <div>
      <div className="page-header">
        <h1>Team <span>Members</span></h1>
        <button className="btn-red" onClick={openAdd}>+ Add User</button>
      </div>

      <div style={{ background: '#1a1a1a', border: '1px solid #222', borderRadius: 10, padding: 16, marginBottom: 24 }}>
        <div style={{ fontSize: 13, color: '#888', marginBottom: 12 }}>Role Permissions</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
          {[
            { role: 'admin', label: 'Admin', perms: ['Full access', 'Sees internal cost', 'Manage users', 'Create deals', 'Delete vehicles'] },
            { role: 'manager', label: 'Manager', perms: ['Add/edit vehicles', 'Upload photos', 'Create deals', 'No internal cost', 'No user management'] },
            { role: 'staff', label: 'Staff', perms: ['Add vehicles', 'Upload photos', 'View inventory', 'No pricing details', 'No deals'] },
          ].map(r => (
            <div key={r.role} style={{ background: '#111', borderRadius: 8, padding: 12, border: `1px solid ${roleColors[r.role].border}` }}>
              <div style={{ color: roleColors[r.role].color, fontWeight: 700, marginBottom: 8, fontSize: 13 }}>{r.label}</div>
              {r.perms.map(p => <div key={p} style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>• {p}</div>)}
            </div>
          ))}
        </div>
      </div>

      {loading ? <div className="loading">Loading...</div> : (
        <table className="data-table">
          <thead><tr>
            <th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Status</th><th>Actions</th>
          </tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td><strong>{u.name}</strong>{u.id === currentUser.id && <span style={{ fontSize: 10, color: '#555', marginLeft: 6 }}>(you)</span>}</td>
                <td style={{ color: '#888' }}>{u.email}</td>
                <td style={{ color: '#888' }}>{u.phone || '—'}</td>
                <td>
                  <span style={{ padding: '3px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700, background: roleColors[u.role]?.bg, color: roleColors[u.role]?.color, border: `1px solid ${roleColors[u.role]?.border}` }}>
                    {u.role.toUpperCase()}
                  </span>
                </td>
                <td>
                  <span style={{ color: u.active ? '#4caf50' : '#ff4444', fontWeight: 700, fontSize: 12 }}>
                    {u.active ? 'Active' : 'Suspended'}
                  </span>
                </td>
                <td style={{ display: 'flex', gap: 4 }}>
                  <button className="btn-ghost" onClick={() => openEdit(u)}>Edit</button>
                  {u.id !== currentUser.id && (
                    <>
                      <button className="btn-ghost" onClick={() => toggleActive(u)} style={{ borderColor: u.active ? '#ff9800' : '#4caf50', color: u.active ? '#ff9800' : '#4caf50' }}>
                        {u.active ? 'Suspend' : 'Activate'}
                      </button>
                      <button className="btn-ghost" onClick={() => deleteUser(u.id, u.name)} style={{ borderColor: '#ff4444', color: '#ff4444' }}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <h2>{editing ? 'Edit User' : 'Add Team Member'}</h2>
              <button className="modal-close" onClick={() => setModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group"><label>Full Name</label><input value={form.name} onChange={e => set('name', e.target.value)} placeholder="John Smith" /></div>
                <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="(555) 000-0000" /></div>
                {!editing && <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="john@dealership.com" /></div>}
                <div className="form-group"><label>{editing ? 'New Password (leave blank to keep)' : 'Password'}</label><input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder={editing ? 'Leave blank to keep current' : 'Set a password'} /></div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}><label>Role</label>
                  <select value={form.role} onChange={e => set('role', e.target.value)}>
                    <option value="staff">Staff — Add vehicles and photos only</option>
                    <option value="manager">Manager — Add/edit vehicles, create deals</option>
                    <option value="admin">Admin — Full access</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-red" onClick={save} disabled={saving}>{saving ? 'Saving...' : editing ? 'Update User' : 'Create User'}</button>
              <button className="btn-outline" onClick={() => setModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
